<div>
    <cw-input-expression *ngIf="getFieldsData() as editorData" labelText="{{label | translate}}"
        [placeholderText]="placeholder" [fieldsExpression]="editorData" [expression]="property.value"
        [fieldName]="property.field" [isEditable]="property.editable()" [isValid]="isValidExpression"
        (expressionChange)="onChange($event)"></cw-input-expression>
</div>